import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconView';
/** Renders an SVG icon. */
const SvgView = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.889 21.508a14 14 0 0 0 18.222 0l3.768-3.23a3 3 0 0 0 0-4.556l-3.768-3.23a14 14 0 0 0-18.222 0l-3.768 3.23a3 3 0 0 0 0 4.556zm16.92-1.519a12 12 0 0 1-15.618 0l-3.769-3.23a1 1 0 0 1 0-1.518l3.769-3.23a12 12 0 0 1 15.619 0l3.768 3.23a1 1 0 0 1 0 1.518l-3.768 3.23ZM16 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-4-2a4 4 0 1 0 8 0 4 4 0 0 0-8 0"
      />
    </svg>
  );
};
SvgView.displayName = displayName;
export default SvgView;
